import React, { useState, useEffect } from "react";
import "./PublicSite.css";

const COOKIE_KEY = "cookie_consent";

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(COOKIE_KEY, "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <section className="public-cookie-notice" aria-label="Preferenze cookie">
      <p>
        Questo sito utilizza cookie per migliorare l'esperienza utente.
      </p>
      <div className="public-cookie-notice__actions">
        <button type="button" onClick={handleAccept}>
          Accetta
        </button>
        <button type="button" onClick={handleReject}>
          Rifiuta
        </button>
      </div>
    </section>
  );
};

export default CookieConsent;
